import { useId, useRef, useState } from "react";
import './input-year.css'
import TextInput from "./input-text.tsx";
import { useStore } from "../../state/state.ts";
import { PropertiesAutoFillState } from "../../state/types.ts";
import { MIN_BAUJAHR } from "../../state/properties.ts";

export default function YearInput (props: {
  label?: string,
  value: number,
  auto_filled?: PropertiesAutoFillState,
  placeholder?: string | number,
  disabled?: boolean,
  min?: number;
  max?: number;
  onChange: (value: number) => void,
  onBlur?: () => void,
}){
  const placeholder =  props.min ? Math.max(props.min, MIN_BAUJAHR).toString() : props.placeholder ;
  
  return <TextInput
    type="number"
    auto_filled={props.auto_filled}
    decimals={0}
    step={10} 
    min={props.min} 
    max={props.max} 
    hint={"Bitte eine gültige Jahreszahl >"+placeholder+", <"+(props.max)+" eingeben."} 
    label={props.label} 
    value={props.value ? props.value.toString() : ""} 
    placeholder={"z.B. " + placeholder} 
    disabled={props.disabled}
    onChange={(value) => { if (value) { props.onChange(parseInt(value)); } }}
    onMouseDown={(e)=>{
      const rect = e.currentTarget.getBoundingClientRect();
      const relativeX = (e.clientX - rect.left) / rect.width;
      const relativeY = (e.clientY - rect.top) / rect.height;
      if (relativeX > 0.89 && !props.value){
        props.onChange((new Date()).getFullYear());
        (e.currentTarget as HTMLInputElement).select();
      }
    }}
    onKeyDown={(e: React.KeyboardEvent)=>{
      const default_max = props.max || (new Date()).getFullYear();
      const default_min = props.min || 0;
      console.log("key down", e.key, props.value);
      if (e.key === "ArrowDown" && !props.value){
            props.onChange(default_max);
      }
      if (e.key === "ArrowUp" && !props.value){
          props.onChange(default_min);
      }
    }}
    validate={async (v:string)=>{
      let n = parseInt(v);
      return v == "" || n >= (props.min || 0) && n < (props.max || 2100);
    }}
  onBlur={props.onBlur}
  />
}
